export enum UserRoleType {
    Basic = 'Basic',
    ControlledSubstancesOfficer = 'ControlledSubstancesOfficer',
    MedicationsSafetyOfficer = 'MedicationsSafetyOfficer',
    OperationalManager = 'OperationalManager',
    LocalAdmin = 'LocalAdmin',
    Admin = 'Admin',
    Root = 'Root',
}
